import {
  MultiValuedListMore,
  MultiValuedListVariant,
} from '../../../MultiValuedList'

import * as styles from './More.module.css'

function More(props) {
  return (
    <MultiValuedListMore
      {...props}
      className={styles.more}
      size={null}
      variant={MultiValuedListVariant.Tag}
    />
  )
}

export default More
